import { Directive, inject } from '@angular/core';

import { StepperComponent } from '../stepper.component';

/** Button that moves to the next step in a stepper workflow. */
@Directive({
  selector: 'rp-button[rpStepperNext]',
  host: {
    class: 'rp-stepper-next',
    '(click)': 'stepper.next()',
  },
  standalone: true,
})
export class StepperNextDirective {
  stepper = inject(StepperComponent);
}

/** Button that moves to the previous step in a stepper workflow. */
@Directive({
  selector: 'rp-button[rpStepperPrevious]',
  host: {
    class: 'rp-stepper-previous',
    '(click)': 'stepper.previous()',
  },
  standalone: true,
})
export class StepperPreviousDirective {
  stepper = inject(StepperComponent);
}
